import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { TextEntityResponse, CreateTextEntityParams } from 'views/App/Portal/Policy/_types/manuals/draft';

export default function useManageTextEntity() {
  const getTextEntities = async (): Promise<{ content: TextEntityResponse[] }> => {
    try {
      const resp = await fetcher({
        method: 'GET',
        url: `${baseApiUrl()}/lexiverse/text-entity/v1/text-entities`,
      });
      return resp;
    } catch (err) {
      console.error('getTextEntities error:', err);
      throw err;
    }
  };

  const getTextEntityById = async (textEntityId: string): Promise<TextEntityResponse> => {
    try {
      const resp = await fetcher({
        method: 'GET',
        url: `${baseApiUrl()}/lexiverse/text-entity/v1/text-entities/${textEntityId}`,
      });
      return resp as TextEntityResponse;
    } catch (err) {
      console.error('getTextEntityById error:', err);
      throw err;
    }
  };

  const createTextEntity = async (
    params: CreateTextEntityParams,
    onSuccess?: (newTextEntity: TextEntityResponse) => void,
    onError?: (err: ServerErrorResponse) => void
  ) => {
    const { textEntity, description } = params;
    try {
      const resp = await fetcher({
        method: 'POST',
        url: `${baseApiUrl()}/lexiverse/text-entity/v1/text-entities`,
        body: {
          textEntity,
          description,
        },
      });
      if (onSuccess) {
        onSuccess(resp as TextEntityResponse);
      }
    } catch (err) {
      if (onError) {
        handleError(err as Error, { onError });
      } else {
        console.error('createTextEntity error:', err);
      }
    }
  };

  return {
    getTextEntities,
    getTextEntityById,
    createTextEntity,
  };
}
